import styled from "styled-components";

export const Container = styled.div`
    padding: 30px;
`;

export const Details = styled.ul`
    margin: 24px 0;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
    li{
        display: flex;
        flex-direction: column;
        span:first-child{
            font-size: 12px;
            line-height: 16px;
            color: #4a4a4a;
        }
        span:last-child{
            font-size: 16px;
            line-height: 24px;
            color: #000;
            font-weight: 700;
        }
    }
`;
export const Remarks = styled.div`
    padding-bottom: 16px;
    border-bottom: 1px rgba(0,0,0,0.1) solid;
    margin-bottom: 16px;
`;
export const SystemRemarks = styled.div`
    background-color: #FFEDD1;
    border-radius: 4px;
    padding: 8px;
`;

